<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.articleNumber" :getMethod="getArticle"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewArticleContainer",
  mixins: [clientAPI],
  components: {
    ViewEntityContainer,
  },

  data() {
    return {
      entityName: EntityNames.Article
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.articleNumber == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.ArticleChange;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>